import React, {Fragment} from 'react';
import Box from '../layout/Box';
import TillCorrectionForm from './forms/TillCorrectionForm';
import TillCorrectionList from './lists/TillCorrectionList';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import is_numeric from "locutus/php/var/is_numeric";
import ComponentEditor, {
    WrappedComponentEditorPropsType,
    ComponentEditorPropsType,
    referenceActionData
} from "../form/ComponentEditor/ComponentEditor";
import ContextBased from "./Context/ContextBased";
import {validations, ValidationType} from "../form/ComponentEditor/Validation";
import isEqual from "lodash-es/isEqual";
import {postData} from "../../utils/request";

class TillCorrectionEditor extends React.Component<WrappedComponentEditorPropsType, any> {

    protected editor: any;

    getFieldProps = (field) => {
        const props = this.props.getFieldProps(field);
        if (this.props.values[this.props.componentConfig.idfield]) {
            if (this.props.lastClosingDate) {
                if (this.props.values.transaction_date < this.props.lastClosingDate) {
                    props.disabled = true;
                }
            }
        }
        return props;
    }

    saveForm = async () => {
        await this.props.saveForm();
        this.editor?.hide();
    }

    deleteForm = async () => {
        await this.props.deleteForm();
        this.editor?.hide();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor?.focus();
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    render() {

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        return (
            <Fragment>
                <List
                    {...this.props}
                    pristineForm={this.pristineForm}
                    saveForm={this.saveForm}
                    loadForm={this.loadForm}
                    theme="default"
                    header="Korrekciók"
                    footer={[
                        <Button
                            key="0"
                            color="default"
                            disabled={this.props.isLoading}
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <TillCorrectionList
                        {...this.props}
                        pristineForm={this.pristineForm}
                        saveForm={this.saveForm}
                        loadForm={this.loadForm}
                        disabled={this.props.disabled || this.props.isLoading}
                        getFieldProps={this.getFieldProps}
                    />
                </List>
                <Editor
                    ref={(editor) => this.editor = editor}
                    {...this.props}
                    pristineForm={this.pristineForm}
                    saveForm={this.saveForm}
                    loadForm={this.loadForm}
                    disabled={this.props.disabled || this.props.isLoading}
                    theme="default"
                    header="Korrekció"
                    footer={<Fragment>
                        <this.props.saveButton
                            saveForm={this.saveForm}
                        />
                        <this.props.deleteButton
                            deleteForm={this.deleteForm}
                        />
                    </Fragment>}
                >
                    <TillCorrectionForm
                        {...this.props}
                        pristineForm={this.pristineForm}
                        saveForm={this.saveForm}
                        loadForm={this.loadForm}
                        disabled={this.props.disabled || this.props.isLoading}
                        getFieldProps={this.getFieldProps}
                    />
                </Editor>
            </Fragment>
        );
    }
}

const actionValidation = async ({data}): Promise<ValidationType> => {
    let messages = null;
    messages = await validations(
        messages,
        data,
        [
            // vatrate closing validations
            ...Object.keys(data?.vatrates || {}).reduce((all, idx) => {
                return [
                    ...all,
                    {
                        field: "vatrates." + idx + ".amount",
                        validation: ({value}) => is_numeric(value),
                        type: ({valid}) => valid ? "valid" : "error",
                        message: ({valid}) => !valid ? "Kérlek töltsd ki!" : true
                    }
                ]
            }, [])
        ]
    );
    return messages;
};

export default (props: ComponentEditorPropsType) => (
    <ContextBased needle="till">
        <ComponentEditor
            componentName="TillCorrection"
            actionValidation={actionValidation}
            dirty={({values, initialValues}) => {
                return !isEqual(values, initialValues);
            }}
            pristineValues={({till}) => {
                return {
                    till,
                    vatrates: JSON.parse(JSON.stringify(till.vatrates.map((vatrate) => {
                        return {vatrate};
                    })))
                };
            }}
            initialValues={({till, values, initialValues}) => {
                if (!values?.id) {
                    return {
                        till,
                        vatrates: JSON.parse(JSON.stringify(till.vatrates.map((vatrate) => {
                            return {vatrate};
                        })))
                    };
                } else {
                    return initialValues;
                }
            }}
            saveForm={async ({requestData, componentConfig}) => {
                requestData.data = await referenceActionData(requestData.data, componentConfig);
                return postData(requestData);
            }}
            {...props}
        >
            <TillCorrectionEditor />
        </ComponentEditor>
    </ContextBased>
);